// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RR6hy5","wrapper--mobile":"_9VM1tm","message":"_2giX77","contact":"_nddyx"};